/* global MEDIA_ROOT */

import React from 'react';

const ArrowRight = props => (
  <img {...props} src={`${MEDIA_ROOT}/icons/icn_arrowright.svg`} alt="Arrow right" />
);

export default ArrowRight;



// WEBPACK FOOTER //
// ./app/src/components/Iconography/components/ArrowRight/index.jsx